module.exports = __webpack_public_path__ + "static/media/kitlogo.215c2076.jpg";